import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { StatsSection } from '../components/StatsSection';
import { BlogExcerpts } from '../components/BlogExcerpts';
import { NearestLocationFinder } from '../components/NearestLocationFinder';
import { BookingCTA } from '../components/BookingCTA';
import { InsuranceLogos } from '../components/InsuranceLogos';
import { VirtualTryOn } from '../components/VirtualTryOn';
import { ContactLensOrderSection } from '../components/ContactLensOrderSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { ReviewExcerpts } from '../components/ReviewExcerpts';
import { SocialMediaSection } from '../components/SocialMediaSection';
import { ShopFramesSection } from '../components/ShopFramesSection';
export function HomePage() {
  return <>
      <HeroSection data-id="element-911" />
      <ServicesSection data-id="element-912" />
      <VirtualTryOn data-id="element-913" />
      <ReviewExcerpts data-id="element-914" />
      <StatsSection data-id="element-915" />
      <BlogExcerpts data-id="element-916" />
      <ShopFramesSection data-id="element-917" />
      <NearestLocationFinder data-id="element-918" />
      <SocialMediaSection data-id="element-919" />
      <BookingCTA data-id="element-920" />
      <InsuranceLogos data-id="element-921" />
      <ContactLensOrderSection data-id="element-922" />
      <ReviewsSection data-id="element-923" />
    </>;
}